import React from "react";
import styled from "styled-components";
import { Alert } from "../../../../design-system";

const NotificationContainer = styled.div`
`;

export default (props) => {
  const [notifications, setNotifications] = React.useState([]);

  React.useEffect(() => {
    if (props.notifications) {
      setNotifications(props.notifications);
    }
  }, [props.notifications]);

  return (
    <NotificationContainer>
      {notifications.map((notification, idx) => (
        <Alert
          key={`top-header-notification-${idx}`}
          variant={notification.type}
          message={notification.label}
          actionLabel={notification.buttonLabel}
          onActionClick={notification.buttonClick}
        />
      ))}
    </NotificationContainer>
  );
};




// WEBPACK FOOTER //
// ./src/views/AppViews/TopHeader/TopHeaderNotifications/index.jsx